<template>
  <div class="chat">
    <div class="chat-head">
      <img src="@/assets/image/icon-chat.png" alt="" />
    </div>
    <div class="chat-content" ref="chatBox">
      <div
        v-for="(item, index) in chatList"
        :key="index"
        class="chat-content-box"
        :class="item.userID == UserId ? 'type1' : 'type2'"
      >
        <div class="box-name">
          <b>{{ item.userName }}</b>
          <span>{{ formatDate(item.sendTime) }}</span>
        </div>
        <div class="box-text">
          <div v-if="item.messageType == 1">
            {{ item.content }}
          </div>
          <div v-else>
            <img
              class="imageMessage"
              :src="`data:image/png;base64, ${parseContent(item.content)}`"
              @click="openImagePreview(item)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="chat-bottom">
      <div class="chat-bottom-left">
        <div class="chat-bottom-link" @click="triggerFileInput">
          <img src="@/assets/image/icon-link.png" alt="" />
        </div>
        <input
          type="file"
          ref="fileInput"
          @change="handleFileUpload"
          style="display: none"
        />
        <span class="chat-bottom-span"></span>
        <div class="chat-bottom-input">
          <input
            type="text"
            placeholder="請輸入訊息 Type your message."
            v-model="chatMessage"
            @keyup.enter="sendChatMessage"
          />
        </div>
      </div>
      <div class="chat-bottom-right">
        <div class="chat-bottom-send" @click="sendChatMessage">
          <img src="@/assets/image/icon-send.png" alt="" />
        </div>
      </div>
    </div>
    <div
      v-if="showImagePreview"
      class="image-preview-overlay"
      @click.self="closeImagePreview"
    >
      <img :src="previewImageSrc" class="image-preview-large" />
      <button class="close-btn" @click="closeImagePreview">✕</button>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "teacher-chat",
  data() {
    return {
      // 消息輸入框
      chatMessage: "",
      // 歷史消息列表
      chatList: [],
      fileUploads: null,
      fileUploadsBase64: null,
      showImagePreview: false,
      previewImageSrc: '',
    };
  },
  computed: {
    ...mapGetters(["liveChats", "LiveChatChannel", "UserId", "UserName"]),
  },
  watch: {
    chatList: {
      handler(newVal, oldVal) {
        this.handleScrollBottom();
      },
      deep: true,
    },
  },
  created() {
    this.retrieveChatsMessage();
  },
  methods: {
    // 滚动到底部
    handleScrollBottom() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const scrollElem = this.$refs.chatBox;
          scrollElem.scrollTo({
            top: scrollElem.scrollHeight,
            behavior: "smooth",
          });
        });
      });
    },
    // 鏈接按鈕點擊
    linkClick() {},
    // 發送信息（發送之後調用handleScrollBottom 即可滾動到最底部）
    sendClick() {
      if (this.chatMessage !== "") {
        this.chatList.push({
          type: 1, // 1自己 2別人
          name: "Teacher’s name",
          time: "2023-05-23 14:55:00",
          content: this.chatMessage,
        });
        this.chatMessage = "";
        this.handleScrollBottom();
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Check MIME type
      if (!file.type.startsWith("image/")) {
        alert("Only image files are allowed.");
        return;
      }

      this.fileUploads = event.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(this.fileUploads);
      reader.onload = (e) => {
        this.fileUploadsBase64 = e.target.result;
        this.fileUploadsBase64 = this.fileUploadsBase64.replace(
          /^data:image\/[a-z]+;base64,/,
          ""
        );
        if (this.fileUploadsBase64 != "") {
          let formData = new FormData();
          formData.append("file", this.fileUploads);
          this.chatMessage = this.fileUploads.name;
        } else {
          alert("Please Try Again");
        }
      };
    },
    async sendChatMessage() {
      if (this.fileUploads != null) {
        this.sendFileMessage();
      } else {
        if (this.chatMessage != "") {
          const sendTime = Date.now();
          const msgContent = this.chatMessage;
          // 樂觀更新：立即顯示訊息，不等待 API 回應
          this.chatList.push({
            userID: this.UserId,
            userName: this.UserName,
            messageType: 1,
            isMySelf: true,
            content: msgContent,
            sendTime,
          });
          this.chatMessage = "";
          // 背景發送，完成後同步伺服器資料
          this.$emit("retrieveChats", {
            userID: this.UserId,
            userName: this.UserName,
            messageType: 1,
            isMySelf: true,
            content: msgContent,
            sendTime,
          });
          this.$axios.post(`/classroomlivechat`, {
            liveChatChannel: this.LiveChatChannel,
            messageType: 1,
            isMySelf: true,
            userID: this.UserId,
            userName: this.UserName,
            content: msgContent,
            sendTime,
          });
        } else {
          alert("Chat Message is Empty");
        }
      }
    },
    async sendFileMessage() {
      console.log("fileData", this.fileUploads);
      if (this.fileUploads.name != "") {
        const sendTime = Date.now();
        const fileUploadsBase64 = this.fileUploadsBase64;
        const fileName = this.chatMessage;
        // 樂觀更新：立即顯示圖片訊息
        this.chatList.push({
          userID: this.UserId,
          userName: this.UserName,
          messageType: 2,
          isMySelf: true,
          content: JSON.stringify({ base64: fileUploadsBase64, fileName }),
          sendTime,
        });
        this.fileUploads = null;
        this.fileUploadsBase64 = null;
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = '';
        }
        this.chatMessage = "";
        // 背景發送，完成後同步伺服器資料
        this.$emit("retrieveChats", {
          userID: this.UserId,
          userName: this.UserName,
          messageType: 2,
          isMySelf: true,
          content: JSON.stringify({ base64: fileUploadsBase64, fileName }),
          sendTime,
        });
        this.$axios.post(`/classroomlivechat`, {
          liveChatChannel: this.LiveChatChannel,
          messageType: 2,
          isMySelf: true,
          userID: this.UserId,
          userName: this.UserName,
          content: JSON.stringify({ base64: fileUploadsBase64, fileName }),
          sendTime,
        });
      } else {
        alert("File Message is Empty");
      }
    },
    async retrieveChatsMessage() {
      this.$store.dispatch("retrieveChats", {
        ClassroomId: this.$store.state.classRoomId,
        MessageDisplayQty: 100,
      });
      await this.$axios
        .get(
          `/classroomlivechat/details?liveChatChannel=${this.LiveChatChannel}`
        )
        .then((response) => {
          console.log("retrieveChats", response);
          this.chatList =
            response.data.payload.liveChat.length > 0
              ? response.data.payload.liveChat
              : [];
          this.handleScrollBottom();
        });
    },
    parseContent(content) {
      if (!content) {
        return "No content";
      }
      try {
        const parsedContent = JSON.parse(content);
        return parsedContent.base64.replace(/"/g, "") || "No message";
      } catch (e) {
        console.error("Error parsing content:", e);
        return "Invalid content";
      }
    },
    addMessage(msg) {
      this.chatList.push(msg);
      this.handleScrollBottom();
    },
    formatDate(timestamp) {
      const date = new Date(Number(timestamp));
      return date.toDateString();
    },
    openImagePreview(item) {
      this.previewImageSrc = `data:image/png;base64, ${this.parseContent(item.content)}`;
      this.showImagePreview = true;
    },
    closeImagePreview() {
      this.showImagePreview = false;
      this.previewImageSrc = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.chat {
  margin-top: 12px;
  width: 100%;
  height: 320px;
  // height: calc((100% - 24px) / 3);
  // min-height: 260px;
  border-radius: 8px;
  border: 1px solid var(--unnamed, #e9e9ea);
  background: #fff;
  overflow: hidden;
  .chat-head {
    width: 100%;
    height: 40px;
    background: var(--unnamed, #647cb1);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .chat-content {
    padding: 12px;
    width: 100%;
    height: calc(100% - 90px);
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE10+ */
    &::-webkit-scrollbar {
      display: none; /* ChromeSafari */
    }
    .chat-content-box {
      margin-bottom: 10px;
      display: flex;
      flex-wrap: wrap;
      .box-name {
        margin-bottom: 6px;
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        color: #333;
        font-size: 16px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        span {
          margin-left: 6px;
          color: #bfbfbf;
          font-size: 10px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
      .box-text {
        max-width: 100%;
        min-height: 49px;
        padding: 14px 16px;
        border-radius: 6px;
        color: #fff;
        font-size: 16px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .imageMessage {
        max-width: 100%;
        max-height: 100px;
        width: auto;
        height: auto;
      }
    }

    .type1 {
      justify-content: flex-end;
      .box-name {
        justify-content: flex-end;
      }
      .box-text {
        border-top-right-radius: 0;
        background: #333;
      }
    }
    .type2 {
      .box-text {
        border-top-left-radius: 0;
        background: #647cb1;
      }
    }
  }
  .chat-bottom {
    padding: 0 20px;
    width: 100%;
    height: 50px;
    border-top: 1px solid var(--unnamed, #e9e9ea);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .chat-bottom-left {
      width: calc(100% - 62px);
      display: flex;
      align-items: center;
      .chat-bottom-link {
        cursor: pointer;
        user-select: none;
        width: 40px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background: #f3f4f6;
        }
      }
      .chat-bottom-span {
        margin: 0 10px 0;
        width: 1px;
        height: 26px;
        background: #e9e9ea;
      }
      .chat-bottom-input {
        flex: 1;
        height: 40px;
        padding: 0 6px;
        input {
          width: 100%;
          height: 100%;
          border: none;
          background: none;
          font-size: 14px;
          font-family: Microsoft JhengHei;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          &:focus {
            outline: none;
          }
          &::placeholder {
            color: #989898;
          }
        }
      }
    }
    .chat-bottom-right {
      width: 62px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .chat-bottom-send {
        cursor: pointer;
        user-select: none;
        width: 40px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background: #f3f4f6;
        }
      }
    }
  }
}
.image-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.image-preview-large {
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 8px;
}

.close-btn {
  position: fixed;
  top: 20px;
  right: 30px;
  font-size: 30px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}

</style>
